import {
    isJSON
} from "@/utils/object.utils"
import {
    isNumeric
} from "@/utils/math.utils";
import links from '@/constants/links';
import actions from "@/store/actions";
import {
    app
} from '@/app';

/**
 * Is logged
 */
export const isLogged = () => (getAuthToken());

/**
 * Set User
 */
export const setUser = (user) => {
    Object.keys(user || {}).map((key) => {
        if (typeof user[key] == "object") {
            sessionStorage.setItem(key, JSON.stringify(user[key]));
        } else {
            sessionStorage.setItem(key, user[key]);
        }
        return null
    })
}

/**
 * Get User
 */
export const getUser = () => {
    const user = {};
    Object.keys(sessionStorage).map((key) => {
        const value = sessionStorage.getItem(key);
        if (isJSON(value)) {
            user[key] = JSON.parse(value);
        } else if (isNumeric(value)) {
            user[key] = parseInt(value, 0);
        } else {
            user[key] = value;
        }
        return null
    })
    return user;
}

/**
 * Logout
 */
export const Logout = () => {
    sessionStorage.clear();
    actions.updateNotifications();
    actions.updateUser();
    actions.updateUserRestrictions()
    app.then(({
        $router
    }) => {
        $router.push({
            path: links.routes.welcome
        });
    });
}

/**
 * set Auth Token
 */
export const setAuthToken = (token) => sessionStorage.setItem('authToken', token)

/**
 * Get Auth Token
 */
export const getAuthToken = () => sessionStorage.getItem('authToken') || ''

/**
 * Set Zushin Points
 * @param {number} points
 */
export const setZP = (points) => {
    sessionStorage.setItem('zushinPoints', points)
    const gameAccount = JSON.parse(sessionStorage.getItem('game_account') || "{}") || {};

    const newGameAccount = {};
    Object.keys(gameAccount).map((key) => {
        newGameAccount[key] = gameAccount[key]
        if (key === 'login_fee_point') {
            newGameAccount[key] = points;
        }
        return null;
    })
    sessionStorage.setItem('game_account', JSON.stringify(newGameAccount))
}
